
export default {
    getVagaBeneficio(state) {
        return state.vagaBeneficio
    },
    getVagasBeneficios(state) {
        return state.vagasBeneficios
    },
}